<style scoped="scoped" lang="scss">
.info {
  background-color: #F7F8FA;
  height: 28px;
  display: flex;
  margin-bottom: 12px;
  align-items: center;
  justify-content: flex-end;
  line-height: 28px;
  color: #419FFF;
  font-size: 12px;
  font-family: 'Microsoft YaHei UI';
}

.info-item {
  width: 100%;
  text-align: right;
  color: #419fff;
  display: flex;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/report/page/equipment_run_status_report" getKey="rows" :columns="columns">
      <template #top><!--  信息-->
        <div class="info" v-loading="searchLoading">
          <div class="info-item">
            <div style="flex: 1; text-align: right;">{{$t('meiri09:00gengxinzuorishuju')}}</div>
            <div style="margin-left: 20px;" v-if="utils.checkPower('web_report_equipment_run_report_refresh')">
              <el-button size="mini" @click="refresh" type="primary">{{ $t('jishishengchengshangyirishuju') }}</el-button>
            </div>
          </div>
        </div>
      </template>
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('xuanzeriqi')">
            <yi_time_input format="yyyy-MM-dd" type="daterange" :minTime="90 * 24 * 3600 * 1000" :maxTime="90 * 24 * 3600 * 1000" :start.sync="yt.conditions.summaryDateStart" :end.sync="yt.conditions.summaryDateEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :ids.sync="yt.conditions.orgIdSelected" :idsPath.sync="yt.conditions.orgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentId"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="reset()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL> </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 自定义某个字段 -->

      <template #zhuangtaifenbutu="scope">
        <div style="height: 16px;background:#7582A3;width: 100%;display: flex;">
          <div style="height: 20px;" :style="{ width: status.percent * 100 + '%', background: statusColors[status.s + ''] }" v-for="status in makeStatus(scope.row)"></div>
        </div>
      </template>
      <!-- <template #jiqijiluchanliang="scope">
        {{scope.row.shiftProduction === '' ? 0: scope.row.shiftProduction}}
       
      </template> -->
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
import XLSX from 'xlsx';

export default {
  name: 'web_report_equipment_run_report_list',
  data() {
    return {
      exportLoading: false,
      statusColors: {
        '-1': '#7582A3',
        '0': '#7DFFBE',
        '1': '#FFD580',
        '3': '#FF809F'
      },
      // statusColors: ["#7582A3","#7DFFBE","#FFD580","#FF809F"],
      status: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ],

      columns: [
        {
          label: 'shebeimingcheng',
          prop: 'equipmentName',
          sort: true
        },
        {
          label: 'suoshuzuzhi',
          prop: 'orgName',
          sort: true
        },
        {
          label: 'riqi',
          type: 'time',
          format: 'YYYY-MM-DD',
          prop: 'summaryDate',
          sort: 'number'
        },
        {
          label: 'banci',
          prop: 'shiftName',
          sort: true
        },
        {
          label: 'bancikaishishijian',
          type: 'time',
          prop: 'startTime',
          format: 'YYYY-MM-DD HH:mm:ss'
        },
        {
          label: 'bancijieshushijian',
          type: 'time',
          prop: 'endTime',
          format: 'YYYY-MM-DD HH:mm:ss'
        },
        {
          label: 'jiqijiluchanliang',
          prop: 'shiftProduction',
          formatter: scope => {
            return (scope.row.shiftProduction == null ? 0: scope.row.shiftProduction);
          }
        },
        {
          label: 'kaihemocishu',
          prop: 'totalMould',
          formatter: scope => {
            return (scope.row.totalMould == null ? 0: scope.row.totalMould);
          }
        },
        {
          label: 'yunxingshijian(xiaoshi)',
          prop: 'runDuration',
          formatter: scope => {
            return (scope.row.runDuration / 3600.0 / 1000.0).toFixed(1);
          }
        },
        {
          label: 'kongxianshijian(xiaoshi)',
          prop: 'idleDuration',
          formatter: scope => {
            return (scope.row.idleDuration / 3600.0 / 1000.0).toFixed(1);
          }
        },
        {
          label: 'guzhangshijian(xiaoshi)',
          prop: 'errorDuration',
          formatter: scope => {
            return (scope.row.errorDuration / 3600.0 / 1000.0).toFixed(1);
          }
        },
        {
          label: 'lixianshijian(xiaoshi)',
          prop: 'shutdownDuration',
          formatter: scope => {
            return (scope.row.shutdownDuration / 3600.0 / 1000.0).toFixed(1);
          }
        },
        {
          label: 'kaijilv',
          prop: 'startupRate',
          formatter: scope => {
            return (scope.row.startupRate * 100.0).toFixed(1) + '%';
          }
        },
        {
          label: 'jiadonglv',
          prop: 'runRate',
          formatter: scope => {
            return (scope.row.runRate * 100.0).toFixed(1) + '%';
          }
        },
        {
          label: 'zhuangtaifenbutu',
          type: 'slot',
          width: 150
        }
      ],
      // 导出的字段配置
      exportColumns: [
        {
          label: 'shebeimingcheng',
          prop: 'equipmentName'
        },
        {
          label: 'suoshuzuzhi',
          prop: 'orgName'
        },
        {
          label: 'riqi',
          prop: 'summaryDateStr'
        },
        {
          label: 'banci',
          prop: 'shiftName'
        },
        {
          label: 'bancikaishishijian',
          prop: 'startTimeStr'
        },
        {
          label: 'bancijieshushijian',
          prop: 'endTimeStr'
        },
        {
          label: 'jiqijiluchanliang',
          prop: 'shiftProduction'
        },
        {
          label: 'kaihemocishu',
          prop: 'totalMould'
        },
        {
          label: 'yunxingshijian(xiaoshi)',
          prop: 'run'
        },
        {
          label: 'kongxianshijian(xiaoshi)',
          prop: 'idle'
        },
        {
          label: 'guzhangshijian(xiaoshi)',
          prop: 'error'
        },
        {
          label: 'lixianshijian(xiaoshi)',
          prop: 'shutdown'
        },
        {
          label: 'kaijilv',
          prop: 'startupRate'
        },
        {
          label: 'jiadonglv',
          prop: 'runRate'
        }
      ]
    };
  },
  computed: {
    makeStatus() {
      return row => {
        if (row.status) {
          //总时长
          let newStatus = row.status.map(item => {
            item.last = this.dayjs(item.et).unix() - this.dayjs(item.st).unix();
            return {
              percent: item.last / (row.endTime / 1000 - row.startTime / 1000),
              s: item.s,
              st: item.st,
              et: item.et,
              name: '',
              type: 'bar',
              stack: 'total',
              label: {
                show: false
              },
              emphasis: {
                focus: 'series'
              },
              itemStyle: {
                normal: {
                  color: this.statusColors[item.s + ''],
                  barBorderRadius: 0
                }
              },
              data: [item.last]
            };
          });
          return newStatus;
        }
      };
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.summaryDateStart = this.dayjs()
        .startOf('month')
        .valueOf();
      this.yt.conditions.summaryDateEnd = this.dayjs()
        .endOf('day')
        .valueOf();
      this.$nextTick(() => {
        this.yt.conditions.orgIdSelected = this.store.state.organizations[0].id;
        this.yt.get(1);
      });
    }, 300);
  },

  methods: {
    reset() {
      this.$set(this.yt.conditions, 'equipmentId', '');
      this.$set(
        this.yt.conditions,
        'summaryDateStart',
        this.dayjs()
          .startOf('month')
          .valueOf()
      );
      this.$set(
        this.yt.conditions,
        'summaryDateEnd',
        this.dayjs()
          .endOf('day')
          .valueOf()
      );
      this.$nextTick(() => {
        this.yt.conditions.orgIdSelected = this.store.state.organizations[0].id;
        this.yt.get(1);
      });
    },
    refresh(){
      this.$confirm(this.$t('本操作将生成上一天所有班次的设备运行数据，建议在上一天所有班次结束时间后操作，是否确认刷新?'), this.$t('tishi'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      }).then(() => {
        this.searchLoading = true;
        this.http.post('/web/equipment/basic/efficiency/refreshCapacitySummary').then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get();
          this.isShowActionDialog = false;
        }).catch(err => {
          this.utils.errorMessage(err);
        }).finally(() => {
          this.searchLoading = false;
        });
      }).catch(() => {});
    },

	  // 导出Excel
    exportExcel() {
      this.exportLoading = true;
      let params = {
        orgIdSelected: this.yt.conditions.orgIdSelected,
        summaryDateStart: this.yt.conditions.summaryDateStart,
        summaryDateEnd: this.yt.conditions.summaryDateEnd,
        equipmentIds: this.yt.conditions.equipmentId
      }
      this.http
        .get('/web/equipment/basic/efficiency/export', {
          params
        })
        .then(res => {
          const data = res.data;
          this.geneExcel(data);
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },

    // 生成Excel
    geneExcel(data) {
      // 筛选出表头和prop
      let tableFirst = this.exportColumns.map(column => this.$t(column.label));
      let tableProp = this.exportColumns.map(column => column.prop);
      // 顺序封装表格数据
      let tableArr = [];
      tableArr.push(tableFirst);
      for (let i = 0; i < data.length; i++) {
        let dataArr = [];
        for (let j = 0; j < tableProp.length; j++) {
          dataArr.push(data[i][tableProp[j]]);
        }
        tableArr.push(dataArr);
      }
      const worksheet = XLSX.utils.aoa_to_sheet(tableArr);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, `设备运行报表导出_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
    },
  }
};
</script>
